import React from 'react'

import { useAssertContext } from '@hooks/useAssertContext'

interface ReactHookFormExternalSubmitContextValue {
  formRef: React.RefObject<Nullable<HTMLFormElement>>
  triggerSubmit: VoidFunction
}

const ReactHookFormExternalSubmitContext = React.createContext<Nullable<ReactHookFormExternalSubmitContextValue>>(null)

ReactHookFormExternalSubmitContext.displayName = 'ReactHookFormExternalSubmitContext'

export interface ReactHookFormExternalSubmitProviderProps {
  children: React.ReactNode
  preventSubmitSuccess?: VoidFunction
}

export function ReactHookFormExternalSubmitProvider({
  children,
  preventSubmitSuccess,
}: ReactHookFormExternalSubmitProviderProps) {
  const formRef = React.useRef<HTMLFormElement>(null)

  const contextValue = React.useMemo<ReactHookFormExternalSubmitContextValue>(
    () => ({
      formRef,
      triggerSubmit: () => {
        if (formRef.current) {
          preventSubmitSuccess?.() // TODO later remove it - when external "handleSubmitSuccess" connected to form
          formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
        }
      },
    }),
    [preventSubmitSuccess]
  )

  return (
    <ReactHookFormExternalSubmitContext.Provider value={contextValue}>
      {children}
    </ReactHookFormExternalSubmitContext.Provider>
  )
}

export function useReactHookFormExternalSubmit() {
  return useAssertContext(ReactHookFormExternalSubmitContext).triggerSubmit
}

export function useReactHookFormExternalSubmitFormRef() {
  return useAssertContext(ReactHookFormExternalSubmitContext).formRef
}
